<template>
  <div v-if="open" class="modal-overlay" @click="cancel">
    <div class="modal-content" @click.stop>
      <div class="modal-header">
        <h3 class="text-lg font-semibold">{{ title }}</h3>
      </div>
      <div class="modal-body">
        <p class="text-sm text-gray-700">{{ message }}</p>
      </div>
      <div class="modal-footer">
        <button class="btn btn-outline" @click="cancel">Cancel</button>
        <button class="btn btn-primary" @click="confirm">Confirm</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      open: false,
      title: 'Are you sure?',
      message: 'This action cannot be undone.',
      resolve: null,
      reject: null
    }
  },
  created() {
    this.$bus.$on('confirm:open', this.openDialog);
  },
  beforeDestroy() {
    this.$bus.$off('confirm:open', this.openDialog);
  },
  methods: {
    openDialog(payload) {
      this.title = payload.title || this.title;
      this.message = payload.message || this.message;
      this.open = true;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    cancel() {
      this.open = false;
      if (this.reject) this.reject('cancel');
    },
    confirm() {
      this.open = false;
      if (this.resolve) this.resolve('ok');
    }
  }
}
</script>


